export enum ChatEmitsEnum {
  SEND_MESSAGE = "sendMessage",
  SEND_MESSAGE_GROUP = "sendMessageToGroup",
  READ_MESSAGE = "readMessage",
  JOIN_GROUPS = "joinGroups",
  NEW_MESSAGE = "newMessage",
  ONLINE_USERS = "onlineUsers",
  CHECK_ONLINE_USERS = "checkOnline",
  CHECK_ONLINE_GROUP = "checkGroupOnline",
  GROUP_ONLINE_USERS = "groupOnlineUsers",
  CONVERSATION_CHANGED = "conversationChanged",
  DELETE_MESSAGE = "deleteMessage",
  USER_ACCESS = "userAccess",
  RATE_LIMIT = "rateLimit",
}

export enum ConversationTypeEnum {
  PERSONAL = "direct",
  CHANNEL = "channel",
  GROUP = "group",
}

export enum ConversationRole {
  Member = "member",
  Admin = "admin",
  Owner = "owner",
}
